import axios from "axios";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import imgGraph from "../../assets/bg-17bolinhas.webp";
import imgGraph2 from "../../assets/bg-19bolinhas.webp";
import logoAbrafati from "../../assets/logo-abrafati.png";
import CardRelatorio from "../../components/cardRelatorio/cardRelatorio";
import Loading from "../../components/loading/loading";
import PageResultadoTema from "../../components/pageResultadoTema/pageResultadoTema";
import { AuthContext } from "../../contexts/auth";
import configeToken from "../../services/api";
import "./_relatorioConjunto.scss";

HighchartsMore(Highcharts);

function RelatorioConjunto() {
    const printRef = useRef(null);
    const nameUser = JSON.parse(localStorage.getItem("@user")).company_data
        .company;
    const { updateToken, logoutLogin } = useContext(AuthContext);
    const ciclysAkatu = JSON.parse(localStorage.getItem("@ciclysAkatu"));
    const [temasCompletos, setTemasCompletos] = useState([]);
    const [dataTemasRelatorio, setDataTemasRelatorio] = useState(false);
    const [options, setOptions] = useState({});
    const [stageCompany, setStageCompany] = useState({});
    const {
        percent,
        score,
        total_score,
        sector,
        percent_attendance,
        banchmark,
        banchmark_percent_attendance,
    } = dataTemasRelatorio;
    const { id, name, title, description } = stageCompany;
    const [showLoading, setShowLoading] = useState(false);
    const [showSectorData, setShowSectorData] = useState(false);
    const [showBenchmarkData, setShowBenchmarkData] = useState(false);
    const [showBenchmarkInMandala, setShowBenchmarkInMandala] = useState(false);
    const [companyRoleId, setCompanyRoleId] = useState(null);
    const [searchParams] = useSearchParams();
    const anoId = searchParams.get("ano_id");
    const navigate = useNavigate();

    const THEME_QUADRANT_ORDER = [
        "Capital Social",
        "Meio Ambiente",
        "Capital Humano",
        "Governança e Liderança",
    ];

    useEffect(() => {
        document.title = "Abrafati - Relatório geral";
    }, []);

    useEffect(() => {
        const handleBeforePrint = () => {
            Highcharts.charts.forEach((chart) => {
                if (chart) {
                    chart.reflow();
                }
            });
        };

        window.addEventListener("beforeprint", handleBeforePrint);
        return () =>
            window.removeEventListener("beforeprint", handleBeforePrint);
    }, []);

    function buildOrderedSubthemes(themes, relatorioSubthemes) {
        const relatorioMap = {};
        relatorioSubthemes.forEach((s) => {
            relatorioMap[s.id] = s;
        });

        const sortedThemes = THEME_QUADRANT_ORDER.map((name) =>
            themes.find((t) => t.title === name),
        ).filter(Boolean);

        const ordered = [];
        sortedThemes.forEach((theme) => {
            theme.subthemes.forEach((sub) => {
                const relSub = relatorioMap[sub.id];
                if (relSub) ordered.push(relSub);
            });
        });
        return ordered;
    }

    function setOptionsChart(subthemes, showMandala) {
        let array = [];
        let benchmark = [];

        subthemes?.forEach((subtheme) => {
            array.push({
                y: Number(subtheme.value) || 0,
                color: subtheme.color,
            });
            benchmark.push({
                y: Number(subtheme.benchmark) || 0,
                color: subtheme.color,
            });
        });

        return {
            chart: {
                polar: true,
                backgroundColor: "transparent",
                spacing: [30, 30, 30, 30],
            },
            title: {
                text: null,
            },
            pane: {
                startAngle: 0,
                endAngle: 360,
                size: "65%",
            },
            tooltip: {
                shared: true,
                style: {
                    fontSize: "16px",
                },
                formatter: function () {
                    const pointIndex = this.points
                        ? this.points[0].point.index
                        : this.point.index;
                    return (
                        subthemes[pointIndex]?.stage?.description ||
                        subthemes[pointIndex]?.value
                    );
                },
            },
            xAxis: {
                type: "category",
                categories: subthemes?.map((s) => s.title) || [],
                tickmarkPlacement: "on",
                lineWidth: 0,
                labels: {
                    enabled: true,
                    distance: 45,
                    style: {
                        whiteSpace: "normal",
                        width: "120px",
                        fontSize: "12px",
                        textAlign: "center",
                    },
                },
            },
            yAxis: {
                min: 0,
                max: 5,
                tickInterval: 1,
                gridLineInterpolation: "circle",
                labels: {
                    enabled: false,
                },
            },
            plotOptions: {
                series: {
                    pointPlacement: "on",
                },
                column: {
                    pointPadding: 0,
                    groupPadding: 0,
                    minPointLength: 5,
                },
            },
            series: [
                {
                    type: "column",
                    name: "Resultado",
                    data: array,
                    zIndex: 2,
                    opacity: 0.85,
                },
                ...(showMandala
                    ? [
                          {
                              type: "line",
                              name: "Referência",
                              data: benchmark,
                              zIndex: 3,
                              enableMouseTracking: false,
                              dashStyle: "2, 3",
                              lineWidth: 1,
                              color: "#707070",
                              marker: {
                                  enabled: true,
                                  radius: 4,
                                  lineWidth: 1,
                                  lineColor: "#fff",
                              },
                          },
                      ]
                    : []),
                {
                    type: "scatter",
                    name: "Indicadores",
                    data: array.map((item) => ({ y: 5, color: item.color })),
                    zIndex: 4,
                    clip: false,
                    pointPlacement: "on",
                    marker: {
                        symbol: "circle",
                        radius: 12,
                    },
                    enableMouseTracking: false,
                    showInLegend: false,
                },
            ],
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 600,
                        },
                        chartOptions: {
                            pane: {
                                size: "60%",
                            },
                            xAxis: {
                                labels: {
                                    distance: 20,
                                    style: {
                                        fontSize: "10px",
                                        width: "70px",
                                    },
                                },
                            },
                        },
                    },
                ],
            },
        };
    }

    useEffect(() => {
        if (!anoId) return;

        updateToken()
            .then(() => configeToken())
            .then(() => {
                const headers = {
                    Authorization: `Bearer ${localStorage.getItem("@token")}`,
                    "Content-Type": "application/json",
                    Accept: "application/json",
                };

                Promise.all([
                    axios({
                        method: "get",
                        url: `${process.env.REACT_APP_API_URL}/pesquisa/${anoId}/relatorio`,
                        headers,
                    }),
                    axios({
                        method: "get",
                        url: `${process.env.REACT_APP_API_URL}/pesquisa/${anoId}`,
                        headers,
                    }),
                ])
                    .then(([relatorioRes, pesquisaRes]) => {
                        const relatorioData = relatorioRes.data.data;
                        setStageCompany(relatorioData.stage);
                        setDataTemasRelatorio(relatorioData);

                        const showSector =
                            !!pesquisaRes?.data?.data?.show_sector_data;
                        const showBenchmark =
                            !!pesquisaRes?.data?.data?.show_benchmark_data;
                        const showMandala =
                            !!pesquisaRes?.data?.data
                                ?.show_benchmark_in_mandala;

                        setShowSectorData(showSector);
                        setShowBenchmarkData(showBenchmark);
                        setShowBenchmarkInMandala(showMandala);
                        setCompanyRoleId(pesquisaRes?.data?.data?.company_role_id);

                        const baseThemes =
                            pesquisaRes?.data?.data?.themes || [];

                        const requestsTemas = baseThemes.map((theme) =>
                            axios({
                                method: "get",
                                url: `${process.env.REACT_APP_API_URL}/tema/${theme.id}`,
                                headers,
                            }),
                        );

                        Promise.all(requestsTemas)
                            .then((responses) => {
                                const temasDetalhados = responses.map(
                                    (res) => res.data.data,
                                );
                                setTemasCompletos(temasDetalhados);

                                const orderedSubthemes = buildOrderedSubthemes(
                                    baseThemes,
                                    relatorioData.subthemes || [],
                                );
                                setOptions(
                                    setOptionsChart(
                                        orderedSubthemes,
                                        showMandala,
                                    ),
                                );
                                setShowLoading(true);
                            })
                            .catch(() => {
                                setShowLoading(true);
                                toast.warn("Não foi possível carregar os detalhes dos temas do relatório.", {
                                    toastId: "relatorio-conjunto-detalhes-error",
                                });
                                navigate("/downloads");
                            });
                    })
                    .catch((error) => {
                        if (error.response && error.response.status === 401) {
                            logoutLogin();
                        } else {
                            setShowLoading(true);
                            const msg = error.response?.data?.message || "Não é possível visualizar este relatório conjunto pois o questionário deste ciclo ainda não foi respondido/finalizado.";
                            toast.warn(msg, {
                                toastId: "relatorio-conjunto-error",
                                autoClose: 6000,
                            });
                            navigate("/downloads");
                        }
                    });
            });
    }, [anoId, logoutLogin, navigate, updateToken]);

    return (
        <div className="page-relatorio-conjunto" id="imprimir" ref={printRef}>
            {!showLoading && <Loading />}

            {!!dataTemasRelatorio && (
                <>
                    <img
                        className="logo-abrafati-print"
                        src={logoAbrafati}
                        alt="logo da abrafati"
                    />

                    <h2>
                        Ciclo{" "}
                        {
                            ciclysAkatu.find((item) => item.quiz_id == anoId)
                                ?.cycle
                        }
                    </h2>

                    {temasCompletos.map((tema) => (
                        <PageResultadoTema
                            key={tema.id}
                            title={tema.title}
                            subthemes={tema.subthemes}
                            idTema={tema.id}
                        />
                    ))}

                    <div className="container-relatorio downloads">
                        <div className="main-relatorio conjunto">
                            <h2 className="title">
                                Sistema de Avaliação da Sustentabilidade -
                                ABRAFATI
                            </h2>

                            <p className="relatorio__description">
                                O resultado do Sistema de Avaliação da
                                Sustentabilidade, demonstrado a seguir,
                                permitirá compreender o estágio de maturidade da
                                empresa e indicar as questões mais importantes
                                para a construção de uma jornada contínua e a
                                evolução do setor em termos de seu
                                desenvolvimento de programas, procedimentos e
                                soluções voltados à sustentabilidade.
                            </p>

                            <div
                                className={`relatorio__container-results conjunto ${
                                    showBenchmarkData
                                        ? "no-results"
                                        : "resultados"
                                }`}
                            >
                                <div className="relatorio__box-description">
                                    <h4>
                                        Resultado Geral da empresa:{" "}
                                        {`${nameUser}`}
                                    </h4>
                                    <p>
                                        Abaixo o resultado geral com avaliação
                                        do grau de maturidade da empresa,
                                        segundo as práticas de sustentabilidade
                                        e compromissos para o setor:
                                    </p>
                                    <br />
                                </div>

                                <CardRelatorio
                                    key={id}
                                    percent={Math.round(percent)}
                                    estagio={name}
                                    description={description}
                                    descriptionStage={title}
                                    score={Math.round(score)}
                                    percent_attendance={percent_attendance}
                                    banchmark={banchmark}
                                    banchmark_percent_attendance={
                                        banchmark_percent_attendance
                                    }
                                    sector={sector}
                                    total_score={total_score}
                                    idColor={`color-${id}`}
                                    bgColor={`bg-${id}`}
                                    showSectorData={showSectorData}
                                    showBenchmarkData={showBenchmarkData}
                                />
                            </div>

                            <div className="box-relatorio-subtema conjunto">
                                <h4>Resultado por Subtema</h4>
                                <p>
                                    Abaixo o resultado de avaliação por subtema,
                                    representando as práticas empresariais de
                                    sustentabilidade estabelecidas em medida de
                                    escala e o comparativo com resultado
                                    benchmark do setor:
                                </p>
                                <br />
                            </div>

                            <div
                                className={`mandala-section conjunto ${
                                    anoId === 3 ? "center-graph" : ""
                                } ${
                                    showBenchmarkInMandala
                                        ? "resultados"
                                        : "no-all-completed"
                                } ${
                                    dataTemasRelatorio?.subthemes?.length === 17
                                        ? "layout-fabricante"
                                        : ""
                                }`}
                            >
                                <div className="mandala-wrapper">
                                    <img
                                        src={
                                            companyRoleId === 2
                                                ? imgGraph2
                                                : imgGraph
                                        }
                                        className="mandala-bg"
                                        alt="Fundo da Mandala"
                                    />
                                    <div className="mandala-chart">
                                        <HighchartsReact
                                            containerProps={{
                                                style: {
                                                    width: "100%",
                                                    height: "100%",
                                                },
                                            }}
                                            highcharts={Highcharts}
                                            options={options}
                                        />
                                    </div>
                                </div>
                            </div>

                            {showBenchmarkInMandala && (
                                <div className="legenda-benchmark">
                                    <span className="legenda-benchmark__title">
                                        Legenda:
                                    </span>
                                    <svg
                                        width="45"
                                        height="2"
                                        className="legenda-benchmark__line"
                                    >
                                        <line
                                            x1="0"
                                            y1="1"
                                            x2="45"
                                            y2="1"
                                            stroke="#707070"
                                            strokeWidth="2"
                                            strokeDasharray="4, 3"
                                        />
                                    </svg>
                                    <span className="legenda-benchmark__text">
                                        Resultado benchmark
                                    </span>
                                </div>
                            )}

                            <div className="box-relatorio-congratulations conjunto downloads">
                                <h4>Agradecemos a sua participação!</h4>
                                <p>
                                    Continue evoluindo na promoção dos temas
                                    voltados à sustentabilidade. Contribua com
                                    sua experiência e participe de forma ativa
                                    na construção de soluções para o setor de
                                    tintas e vernizes.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="relatorio__box-btns no-print">
                        <button
                            className="btn-print"
                            onClick={() => window.print()}
                        >
                            Imprimir relatório
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}

export default RelatorioConjunto;

